const template = (i) => `<div class="testimonials__item">
    <div class="testimonials__item__body">"${i.body}"</div>
    <div class="testimonials__item__footer">
      <div class="testimonials__item__discipline">${i.orderDiscipline}</div>
      <div class="testimonials__item__id">ID ${i.customerId}XXX</div>
    </div>
  </div>`;

export default template;
